import React from 'react';
import { render } from 'react-dom';
import './PlayerComparable.css';
import axios from 'axios';
import { getHenriColor, getHenriStyle } from '../Utility/utility.js';
import { apiServerUrl } from '../config';
import { authHeader, requestOptions } from '../_helpers';
import ReactTable from 'react-table';
import { makeData, Logo, Tips } from '../Utility/utility.js';
export class Commentlist extends React.Component {
  render() {
    return (
      <div
        className="comparable-player-tile"
        style={{ backgroundColor: '#1e3c51' }}
      >
        <div className="comparable-player-bio-box">
          <div className="comparable-player-photo-box">
            <img
              className="comparable-player-photo"
              src={
                'https://tsnimages.tsn.ca/ImageProvider/PlayerHeadshot?seoId=' +
                this.props.player.playerName
                  .split(' ')[0]
                  .replace('.', '')
                  .replace('.', '') +
                '-' +
                this.props.player.playerName.split(' ')[1] +
                '&width=136&height=136'
              }
              alt="Smiley face"
            />
          </div>
          <div className="comparable-player-bio">
            <div>{this.props.player.playerName.split(' ')[0]}</div>
            <div>{this.props.player.playerName.split(' ')[1]}</div>
            <div style={{ borderTop: '2px solid #94b1c5', color: '#94b1c5' }}>
              {this.props.player.league}|{this.props.player.seasonAge}
            </div>
          </div>
        </div>
        <div className="comparable-player-stats-list">
          <div
            className="comparable-player-stat-entry"
            style={{ backgroundColor: '#1e3c51' }}
          >
            <div className="comparable-player-stat-name">Season:</div>
            <div className="comparable-player-stat-value">
              {this.props.player.season}
            </div>
          </div>
          <div
            className="comparable-player-stat-entry"
            style={{ backgroundColor: '#526978' }}
          >
            <div className="comparable-player-stat-name">PTS:</div>
            <div className="comparable-player-stat-value">
              {this.props.player.p}
            </div>
          </div>
          <div
            className="comparable-player-stat-entry"
            style={{ backgroundColor: '#1e3c51' }}
          >
            <div className="comparable-player-stat-name">PPG:</div>
            <div className="comparable-player-stat-value">
              {this.props.player.ppg ? this.props.player.ppg.toFixed(3) : null}
            </div>
          </div>
          <div
            className="comparable-player-stat-entry"
            style={{ backgroundColor: '#526978' }}
          >
            <div className="comparable-player-stat-name">TO %:</div>
            <div className="comparable-player-stat-value">
              <span style={{ fontWeight: 'bold' }}>
                {this.props.player.toPct
                  ? (this.props.player.toPct * 100).toFixed(2)
                  : null}
              </span>
            </div>
          </div>
          <div
            className="comparable-player-stat-entry"
            style={{ backgroundColor: '#526978' }}
          >
            <div className="comparable-player-stat-name">HENRI:</div>
            <div className="comparable-player-stat-value">
              <span
                style={{
                  color: getHenriStyle(getHenriColor(this.props.player.henri)),
                  fontWeight: 'bold'
                }}
              >
                {getHenriColor(this.props.player.henri).toUpperCase()}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export class PlayerComparable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      playerComps: []
    };
  }
  componentDidUpdate() {
    let component = this;
    //if there are no comparables, skip this section

    //console.log(" player 1" + JSON.stringify(this.props.selectedPlayer.comparables.nhlComparable1));
    //console.log(" player 2" + JSON.stringify(this.props.selectedPlayer.comparables.nhlComparable2));
    let player1 = [];
    let player2 = [];
    let currentComponent = this;
    if (
      currentComponent.props.selectedPlayer.playerID &&
      currentComponent.state.player_id !=
        currentComponent.props.selectedPlayer.playerID
    ) {
      axios
        .get(
          apiServerUrl +
            '/comparable_stats?player_id=' +
            currentComponent.props.selectedPlayer.playerID,
          requestOptions()
        )
        .then(function(response) {
          console.log(response);
          currentComponent.setState({
            playerComps: response.data,
            player_id: currentComponent.props.selectedPlayer.playerID
          });
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
  columns = [
    {
      Header: 'Player',
      id: 'player',
      accessor: d => d.playerName
    },
    {
      Header: 'Season',
      accessor: 'season',
      id: 'season'
    },
    {
      Header: 'Points',
      accessor: 'p',
      id: 'p'
    },
    {
      Header: 'PPG',
      id: 'PPG',
      accessor: d => d.ppg,
      Cell: props => <div> {this.toCurrency(props.value)} </div>
    },
    {
      Header: 'TO%',
      id: 'toPct',
      accessor: 'toPct',
      Cell: props => <div> {this.toCurrency(props.value)} </div>
    },
    {
      Header: 'HENRI',
      id: 'henri',
      accessor: d => (d.henri ? '$' + d.henri.toLocaleString() : null)
    }
  ];

  toCurrency(numberString) {
    let number = parseFloat(numberString);
    return number.toFixed(2);
  }

  render() {
    return (
      <div
        className="comparable-body"
        style={{
          backgroundColor: '#082539'
        }}
      >
        <div
          style={{
            border: '0.2em solid #6e777d',
            borderRadius: '5px'
          }}
        >
          <div className="comparable-header">
            <span>PLAYER COMPARABLES</span>
          </div>
          {this.state.playerComps.length > 1 && (
            <ReactTable
              data={this.state.playerComps}
              columns={this.columns}
              defaultPageSize={10}
              className="-striped -highlight"
              showPagination={false}
            />
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/PlayerComparable.js